import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./styles/app.scss";
import i18n from "./i18n";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

createApp(App)
  .use(store)
  .use(router)
  .use(i18n)
  .component("v-select", vSelect)
  .mount("#app");
